module.exports = __webpack_public_path__ + "static/media/fruitsandveggies.814b4412.png";